import { ReactNode, forwardRef } from "react"
import { TableActionButtonsContainerProps, TableActionButtonProps } from "./types"
import classNames from "classnames"
import {
  BASE_CLASSES,
  BASE_CLASSES_ACTIVE,
  BASE_CLASSES_DISABLED,
  BASE_CLASSES_ENABLED,
  BASE_CLASSES_FOCUS,
  BASE_CLASSES_SM,
} from "../Button/constants"
import { FOCUS_STATE_BASE_CLASSES } from "../utils/focusStateClasses"
import { Box } from "../Box"
import { getButtonBoxAttrs } from "../Button"
import { LoadingSpinner } from "../LoadingSpinner"

export const TableActionButtonsContainer = forwardRef<
  HTMLDivElement,
  TableActionButtonsContainerProps
>((rest, ref) => {
  return (
    <div
      ref={ref}
      className="col-start-1 col-end-[-1] row-start-2 grid grid-flow-col gap-3 md:col-start-auto md:col-end-auto md:row-start-1"
      {...rest}
    />
  )
})
TableActionButtonsContainer.displayName = "Table.ActionButtonsContainer"

export const TableActionButton = forwardRef<HTMLButtonElement, TableActionButtonProps>(
  ({ disabled, isLoading, children: childrenProp, ...rest }, ref) => {
    const { isDisabledStyling, ...attrs } = getButtonBoxAttrs({ disabled, ...rest })

    const _className = classNames(
      "md:row-start-auto",
      BASE_CLASSES_SM,
      BASE_CLASSES.replace("border-2", "border"), // One-off style
      FOCUS_STATE_BASE_CLASSES,
      isDisabledStyling && [BASE_CLASSES_DISABLED, "border-gray-200 bg-gray-100 text-gray-300"],
      !isDisabledStyling && [
        BASE_CLASSES_ENABLED,
        BASE_CLASSES_ACTIVE,
        BASE_CLASSES_FOCUS,
        "text-black border-gray-200 bg-gray-100 focus:border-gray-300 hover:border-gray-300",
      ],
    )

    const children: ReactNode = (
      <div className="grid grid-cols-1 grid-rows-1 place-items-center">
        {isLoading && <LoadingSpinner className="col-start-1 row-start-1" aria-hidden size="sm" />}
        <span className={classNames("col-start-1 row-start-1", isLoading && "invisible")}>
          {childrenProp}
        </span>
      </div>
    )

    return (
      <Box className={_className} ref={ref} {...attrs}>
        {children}
      </Box>
    )
  },
)
TableActionButton.displayName = "Table.ActionButton"
